import { ResourceOptions } from 'react-admin';
import { FaTicketAlt } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxHolidayLotteryConfig;
export const icon = FaTicketAlt;
export const options: ResourceOptions = {
  label: 'module.blindBox.holidayLotteryConfig',
};

